import React from 'react';
import NodeComponent from 'components/customComponents/TreeControl/NodeComponent/NodeComponent';
import EViewType from 'enums/EViewType';
import { getTreeNodeImageProps } from 'utils/Global';
import { getNodeLink } from 'components/customComponents/TreeControl/NodesGroupView/NodesGroupView';
import { ExplorerNode, NODE_ALIGN } from 'components/main/tree/constants';
import { TreeNodeDTO } from 'business/models/Models';
import { FmlxTableCell, FmlxTableRow } from 'fmlx-common-ui';
import { useRightClick } from 'components/rightClick/rightClickProvider';

interface NodeDetailViewRowProps {
  node: ExplorerNode;
  nodeClickHandler: (
    link: string,
    node: TreeNodeDTO,
    id: string,
    expanded: boolean,
    inputNodeName: string,
    eventDetail?: number,
  ) => void;
  selectedNodes: any[];
  selectedExplorerNode: TreeNodeDTO | null;
}

const NodeDetailViewRow = (props: NodeDetailViewRowProps) => {
  const { node, nodeClickHandler, selectedNodes, selectedExplorerNode } = props;
  const { handleRightClick } = useRightClick();
  const isNodeSelected = selectedNodes.find((n) => n?.id === node.id);
  const isLastSelected =
    isNodeSelected && isNodeSelected === selectedNodes[selectedNodes.length - 1];

  const onContextMenuHandler = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (nodeClickHandler && !isNodeSelected) {
      nodeClickHandler(
        getNodeLink(node),
        node,
        `node${node.id}`,
        true,
        `inputNameode${node.id}`,
        1,
      );
    }
    handleRightClick(e);
  };

  return (
    <FmlxTableRow
      data-testid={`table-row-node-${node.id}`}
      key={node.id}
      onClick={() => {}}
      /* @ts-ignore */ // className and onContextMenu props are not in FmlxTableRow prop types but accepts them
      className={`!border-none ${isNodeSelected ? 'node-container-focused' : ''} ${
        isLastSelected ? 'node-container-last-focused' : ''
      }`}
      onContextMenu={onContextMenuHandler}
    >
      <FmlxTableCell
        data-testid={`table-row-cell-node-${node.id}`}
        align={NODE_ALIGN}
        /* @ts-ignore */ // className prop is not in FmlxTableRow prop types but accepts it
        className="!p-0 !border-none"
      >
        <div data-testid={`wrapper-node-${node.id}`} className="!w-72 overflow-hidden">
          <NodeComponent
            data-testid={`node-component-${node.id}`}
            viewType={EViewType.DetailView}
            imageProps={getTreeNodeImageProps(node)}
            name={node.name}
            datePrepared={node?.datePrepared}
            locked={node.locked}
            onClick={(e) => {
              nodeClickHandler(
                getNodeLink(node),
                node,
                `node${node.id}`,
                true,
                `inputNameode${node.id}`,
                e.detail,
              );
            }}
            notSeen={node?.extra?.notSeen}
            selectedNodes={selectedNodes}
            node={node}
            selectedExplorerNode={selectedExplorerNode}
          />
        </div>
      </FmlxTableCell>
      <FmlxTableCell
        data-testid={`table-row-cell-node-dateprepared-${node.id}`}
        align={NODE_ALIGN}
        /* @ts-ignore */ // onClick and className props are not in FmlxTableCell prop types but accepts it
        onClick={(e) => {
          nodeClickHandler(
            getNodeLink(node),
            node,
            `node${node.id}`,
            true,
            `inputNameode${node.id}`,
            e.detail,
          );
        }}
        className="!border-none"
      >
        {node.datePrepared}
      </FmlxTableCell>
      <FmlxTableCell
        data-testid={`table-row-cell-node-last-imaged-${node.id}`}
        align={NODE_ALIGN}
        /* @ts-ignore */ // onClick and className props are not in FmlxTableCell prop types but accepts it
        onClick={(e) => {
          nodeClickHandler(
            getNodeLink(node),
            node,
            `node${node.id}`,
            true,
            `inputNameode${node.id}`,
            e.detail,
          );
        }}
        className="!border-none"
      >
        {node.lastImaged}
      </FmlxTableCell>
      <FmlxTableCell
        data-testid={`table-row-cell-node-owner-${node.id}`}
        align={NODE_ALIGN}
        /* @ts-ignore */ // onClick and className props are not in FmlxTableCell prop types but accepts it
        onClick={(e) => {
          nodeClickHandler(
            getNodeLink(node),
            node,
            `node${node.id}`,
            true,
            `inputNameode${node.id}`,
            e.detail,
          );
        }}
        className="!border-none"
      >
        {node?.extra?.owner}
      </FmlxTableCell>
      <FmlxTableCell
        data-testid={`table-row-cell-node-datedispensed-${node.id}`}
        align={NODE_ALIGN}
        /* @ts-ignore */ // onClick and className props are not in FmlxTableCell prop types but accepts it
        onClick={(e) => {
          nodeClickHandler(
            getNodeLink(node),
            node,
            `node${node.id}`,
            true,
            `inputNameode${node.id}`,
            e.detail,
          );
        }}
        className="!border-none"
      >
        {node.dateDispensed}
      </FmlxTableCell>
    </FmlxTableRow>
  );
};

export default NodeDetailViewRow;
